import React from 'react';
import { Redirect, Route, Switch, BrowserRouter, NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store/store';
import { UNLOG_USER } from './store/slice';

import { LoginPage } from './pages/LoginPage';
import SpecialityTab from './pages/SpecialityTab';
import ReductionTab from './pages/ReductionTab';
import CoachTab from './pages/CoachTab';
import ClientTab from './pages/ClientTab';
import LogPage from './pages/LogPage';
import JobsPage from './pages/JobsPage';
import PayPage from './pages/PayPage';

import './theme/modern.css';

const navItems = [
  { path: '/speciality', label: 'Cours', badge: 'CRS' },
  { path: '/reductions', label: 'Reductions', badge: 'RDX' },
  { path: '/coach', label: 'Coachs', badge: 'COA' },
  { path: '/client', label: 'Clients', badge: 'CLI' },
  { path: '/jobs', label: 'Jobs', badge: 'JOB' },
  { path: '/logs', label: 'Logs', badge: 'LOG' },
  { path: '/pay', label: 'Paiements', badge: 'PAY' }
];

const pageNames: Record<string, string> = {
  '/speciality': 'Cours',
  '/reductions': 'Reductions',
  '/coach': 'Coachs',
  '/client': 'Clients',
  '/jobs': 'Jobs',
  '/logs': 'Logs',
  '/pay': 'Paiements'
};

const DashboardShell: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((s: RootState) => s.slice.name);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-block">
          <div className="brand-mark">H</div>
          <div>
            <div className="brand-title">HopLa</div>
            <div className="brand-subtitle">Supervisor</div>
          </div>
        </div>

        <nav className="nav-list">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className="nav-item" activeClassName="active-nav-item">
              <span className="nav-badge">{item.badge}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-chip">
            <span className="user-dot" />
            {user}
          </div>
          <button className="ghost-btn danger" onClick={() => dispatch(UNLOG_USER())}>
            Deconnexion
          </button>
        </div>
      </aside>

      <main className="main-zone">
        <header className="topbar">
          <h1>{pageNames[location.pathname] ?? 'Supervisor'}</h1>
          <div className="topbar-glow" />
        </header>

        <section className="page-zone">
          <Switch>
            <Route exact path="/speciality" component={SpecialityTab} />
            <Route exact path="/reductions" component={ReductionTab} />
            <Route exact path="/coach" component={CoachTab} />
            <Route exact path="/client" component={ClientTab} />
            <Route exact path="/logs" component={LogPage} />
            <Route exact path="/jobs" component={JobsPage} />
            <Route exact path="/pay" component={PayPage} />
            <Route exact path="/">
              <Redirect to="/speciality" />
            </Route>
          </Switch>
        </section>
      </main>
    </div>
  );
};

const App: React.FC = () => {
  const logged = useSelector((s: RootState) => s.slice.name !== undefined);

  if (!logged) {
    return <LoginPage />;
  }

  return (
    <BrowserRouter>
      <DashboardShell />
    </BrowserRouter>
  );
};

export default App;
